// extracted by mini-css-extract-plugin
export default {"row":"ChatThread_row__IrJ9H","content":"ChatThread_content__vDcGa","divider":"ChatThread_divider__2q0fI","actions":"ChatThread_actions__XKlAE","replies":"ChatThread_replies__dNBzY"};